module.exports = __webpack_public_path__ + "media/images/clube_01-1fcf80e88c8070c04f15de6a1683b8d2.png";